<script>
	export let date = "";
	export let lang = "ja";
	export let list = false;

	let formattedDate = "";
	let week = "";

	$: {
		if (date) {
			let d = new Date(date);
			formattedDate = [
				d.getFullYear(),
				d.getMonth() + 1,
				d.getDate(),
			].join(".");
			let weeks =
				lang === "ja"
					? ["日", "月", "火", "水", "木", "金", "土"]
					: ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
			week = weeks[d.getDay()];
		}
	}
</script>

<p class="UIDate" class:_list={list}>
	{formattedDate}
	<!--曜日あり
		 {formattedDate} <span>[{week}]</span>
		-->
</p>

<style global>
	.UIDate {
		display: inline-block;
		vertical-align: middle;
		color: #fff;
		font-size: 1.25em;
		text-shadow: 0 0 16px rgb(0 0 0 / 50%);
	}
	.UIDate._list {
		display: inline-block;
		vertical-align: middle;
		color: #857e7e;
		font-size: 1.25em;
		text-shadow: none;
	}
	.UIDate > span,
	.UIDate._list > span{
		font-size: 0.8em;
	}
</style>
